import { CircularProgress } from '@mui/material'
import { useSmartPlacement } from '../../../../../CommonComponents/modals/hooks/useSmartPlacement'
import {
    HeaderAction,
    HeaderActionsContainer,
    HeaderTitle,
    HeaderTitleContainer,
    HeaderTitleIcon,
    Modal,
    ModalBody,
    ModalHeader,
    ModalModeType
} from '../../../../../CommonComponents/modals/Modal'
import { GraphReportWindowType } from './AllPresimReportWindows'
import GraphFrame from './GraphFrame'
import './PresimReportWindow.scss'
import { CloseSvg, DownloadSvg, WindowResizeSvg, WindowRightSvg } from '../../../../../CommonComponents/svgs/Svgs'

const GraphReportWindow = ({ icon, title, modalId, targetId, open, pinned, loading, graphs, onExport, windowSize, onModalChange, position, zIndex }: GraphReportWindowType) => {

    const { top, left, bottom, right } = useSmartPlacement(
        targetId,
        modalId,
        "top",
        open,
        pinned,
        {
            top: position.top,
            right: position.right,
            bottom: position.bottom,
            left: position.left
        }
    );


    const onClick = (e: React.MouseEvent, mode: ModalModeType) => {
        onModalChange(e, mode)
    }

    return (
        <Modal id={modalId} open={open} pinned={pinned} className={`presim__report__container`}
            style={{
                width: `${position.width}%`,
                height: `${position.height}%`,
                top: top,
                right: right,
                bottom: bottom,
                left: left,
                zIndex: zIndex
            }}
            onClick={(e) => { onClick(e, 'focus') }}
        >
            <ModalHeader className='presim__report__container__header'>
                <HeaderTitleContainer>
                    <HeaderTitleIcon>
                        {icon}
                    </HeaderTitleIcon>
                    <HeaderTitle>
                        {title}
                    </HeaderTitle>
                </HeaderTitleContainer>
                <HeaderActionsContainer>
                    <div className='d-flex align-items-center gap-3'>
                        <div className='d-flex align-items-center gap-2'>
                            <HeaderAction title={pinned ? 'Unpin' : 'Pin to Right'}
                                className={`${pinned && 'active'}`}
                                onClick={(e) => { onClick(e, 'pinned') }}
                            >
                                <WindowRightSvg />
                            </HeaderAction>
                            <HeaderAction title='Resize'
                                onClick={(e) => { onClick(e, 'resize') }}
                            >
                                <WindowResizeSvg size={windowSize} />
                            </HeaderAction>
                        </div>
                        <div className='d-flex align-items-center gap-2'>
                            <HeaderAction title='Export'
                                onClick={(e) => { onExport(modalId) }}
                            >
                                {loading ? <CircularProgress size={14} color="inherit" /> : <DownloadSvg />}
                            </HeaderAction>
                            <HeaderAction title='Close'
                                onClick={(e) => { onClick(e, 'close') }}
                            >
                                <CloseSvg />
                            </HeaderAction>
                        </div>
                    </div>
                </HeaderActionsContainer>
            </ModalHeader>
            <ModalBody className='overflow-hidden'>
                <GraphFrame
                    title={title}
                    modalId={modalId}
                    graphs={graphs}
                />
            </ModalBody>
        </Modal >
    )
}

export default GraphReportWindow